import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Referensi", path: "/referensi" },
    { label: "About", path: "/about" },
  ];

  const handleNavClick = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? "navbar-scrolled bg-[#0A1628]/95 backdrop-blur-xl shadow-2xl"
          : "bg-[#0A1628]/80 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <button
            onClick={() => handleNavClick("/")}
            data-testid="navbar-logo"
            className="flex items-center gap-2 sm:gap-3 group"
          >
            <img
              src="https://i.ibb.co.com/kgSskVkk/OB-LOGO.png"
              alt="Oerang Borneo Film"
              className="h-10 sm:h-12 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className="text-[#E8761A] font-bold text-sm sm:text-lg tracking-wider hidden xs:block">
              OERANG BORNEO FILM
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => handleNavClick(link.path)}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`font-medium transition-colors duration-300 tracking-wide ${
                  location.pathname === link.path
                    ? "text-[#E8761A]"
                    : "text-white/80 hover:text-[#E8761A]"
                }`}
              >
                {link.label}
              </button>
            ))}

            <a
              href="https://wa.me/6289516500862"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-contact-cta"
              className="btn-primary text-sm px-4 py-2 sm:px-6 sm:py-3"
            >
              Hubungi Kami
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-white/80 hover:text-[#E8761A] transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`md:hidden absolute top-full left-0 right-0 bg-[#0A1628] border-t border-white/10 transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 py-4 space-y-2">
          {navLinks.map((link) => (
            <button
              key={link.path}
              onClick={() => handleNavClick(link.path)}
              data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              className={`block w-full text-left font-medium py-3 px-2 rounded-lg transition-colors ${
                location.pathname === link.path
                  ? "text-[#E8761A] bg-[#E8761A]/10"
                  : "text-white/80 hover:text-[#E8761A] hover:bg-white/5"
              }`}
            >
              {link.label}
            </button>
          ))}

          <a
            href="https://wa.me/6289516500862"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-nav-contact"
            className="block btn-primary text-center mt-4"
          >
            Hubungi Kami
          </a>
        </div>
      </div>
    </nav>
  );
};
